<template>
    <div>
        <div class="field">
            <label class="switch-label">
                <input class="switch" type="checkbox" v-model="isEnabled" /> Enable Integration
            </label>
        </div>
        <div v-if="isEnabled && !isLoading">
            <div :class="integrationDropdownActive ? 'dropdown is-active' : 'dropdown'">
                <div class="dropdown-trigger">
                    <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" @click="integrationDropdownActive = !integrationDropdownActive" @blur="delayIntegrationDropdown">
                        <span>{{ integrationType }}</span>
                        <span class="icon is-small">
                            <font-awesome-icon :icon="['fa', 'angle-down']" />
                        </span>
                    </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                        <a role="button"
                           v-for="(key, value) in genesysIntegrationTypeOptions"
                           :key="key"
                           :value="value"
                           :class="integrationType == value ? 'dropdown-item is-active' : 'dropdown-item'"
                           @click="setGenesysIntegrationType(value)">
                            {{value}}
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="integrationType == 'Genesys CCaaS' || integrationType == 'Genesys Open Messaging'" class="mt-4">
                <div class="field" v-if="integrationType == 'Genesys CCaaS'">
                    <label class="label">Genesys Organization Id</label>
                    <div class="control">
                        <input class="input" type="text" v-model="genesysExternalAccount.genesysOrganizationId">
                    </div>
                </div>
                <div class="field">
                    <label class="label">Client Id</label>
                    <div class="control">
                        <input class="input" type="text" v-model="genesysExternalAccount.clientId">
                    </div>
                </div>
                <div class="field">
                    <label class="label">Client Secret</label>
                    <div class="control">
                        <input class="input" type="text" v-model="genesysExternalAccount.clientSecret">
                    </div>
                </div>
                <label class="label"> Region </label>
                <div :class="regionDropdownActive ? 'dropdown is-active' : 'dropdown'">
                    <div class="dropdown-trigger">
                        <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" @click="regionDropdownActive = !regionDropdownActive" @blur="delayRegionDropdown">
                            <span>{{ genesysExternalAccount.region }}</span>
                            <span class="icon is-small">
                                <font-awesome-icon :icon="['fa', 'angle-down']" />
                            </span>
                        </button>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                            <a role="button"
                               v-for="(region, index) in genesysRegionOptions"
                               :key="index"
                               :value="region"
                               :class="genesysExternalAccount.region == region ? 'dropdown-item is-active' : 'dropdown-item'"
                               @click="setGenesysRegion(region)">
                                {{region}}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="field mt-2">
                    <label class="label">Access Token</label>
                    <div class="control">
                        <input class="input" type="text" v-model="genesysExternalAccount.accessToken">
                    </div>
                </div>
            </div>    
        </div>
    </div>
</template>

<script>
    import { secureGet, securePatch, securePost } from '../secureFetch.js';

    export default {
        name: 'Genesys',
        props: {
            publicAccountId: {
                type: String,
                default: null
            },
            accountId: {
                type: String,
                default: null
            },
            initialIntegrationType: {
                type: String,
                default: null
            }
        },
        computed: {
            hostUrl: function () {
                return this.$store.state.hostUrl;
            },
            integrationUrl: function()  {
                if(this.integrationType == "Genesys Open Messaging") {
                    return "v1/genesysmessaging/external-account/";
                }
                else {
                    return "v1/genesys/external-account/";
                }
            }
        },
        data() {
            return {
                genesysExternalAccount: {},
                externalAccountExists: false,
                integrationType: "Select",
                isEnabled: false,
                isLoading: false,
                integrationDropdownActive: false,
                regionDropdownActive: false,
                genesysIntegrationTypeOptions: {"Select": 0,  "Genesys CCaaS": 4, "Genesys UCaaS": 5, "Genesys Open Messaging": 9},
                genesysRegionOptions: ["US_EAST_1", "US_EAST_2", "US_WEST_2", "EU_WEST_1", "EU_WEST_2", "EU_CENTRAL_1", "AP_NORTHEAST_1",
                    "AP_NORTHEAST_2", "AP_SOUTHEAST_1", "AP_SOUTH_1", "CA_CENTRAL_1", "SA_EAST_1"],
                errorMessage: null
            }
        },
        mounted() {
            if (this.initialIntegrationType != null) {
                this.integrationType = this.initialIntegrationType;
            }
            this.getGenesysExternalAccount();
            this.initializeGenesysExternalAccount();
        },
        methods: {
            setGenesysIntegrationType(type) {
                this.integrationType = type;
            },
            setGenesysRegion(region) {
                this.genesysExternalAccount.region = region;
            },
            delayIntegrationDropdown() {
                setTimeout(() => this.integrationDropdownActive = false, 500);
            },
            delayRegionDropdown() {
                setTimeout(() => this.regionDropdownActive = false, 500);
            },
            getGenesysExternalAccount() {
                this.isLoading = true;

                secureGet(this.hostUrl + this.integrationUrl + this.publicAccountId)
                    .then(data => {
                        if (data && data.success) {
                            this.genesysExternalAccount = data.externalAccount;
                            this.externalAccountExists = true;
                        }

                        this.isLoading = false;
                    })
            },
            initializeGenesysExternalAccount() {
                if (this.initialIntegrationType != null) {
                    this.integrationType = this.initialIntegrationType;
                    this.isEnabled = true;
                }
                if (this.initialIntegrationType != "Genesys CCaaS") {
                    this.genesysExternalAccount.region = "Select";
                }
            },
            save() {
                this.errorMessage = null;
                if (this.initialIntegrationType != null && this.initialIntegrationType != this.integrationType || !this.isEnabled) {
                    this.$emit("delete-account-integration", this.genesysIntegrationTypeOptions[this.initialIntegrationType]);
                }
                if (this.isEnabled) {
                    if(this.initialIntegrationType != this.integrationType) {
                        this.$emit("create-account-integration", this.genesysIntegrationTypeOptions[this.integrationType]);
                        this.createGenesysExternalAccount();
                    }
                    else if(this.externalAccountExists && this.integrationType != "Genesys UCaaS"){
                        this.updateGenesysExternalAccount();
                    }
                    else {
                        this.$emit('saved', { success: true });
                    }
                } else {
                    this.$emit('saved', { success: true });
                }
                this.initialIntegrationType = this.integrationType;
            },
            createGenesysExternalAccount() {
                this.isLoading = true;

                const request = {
                    accountId: this.accountId,
                    genesysOrganizationId: this.genesysExternalAccount.genesysOrganizationId,
                    clientId: this.genesysExternalAccount.clientId,
                    clientSecret: this.genesysExternalAccount.clientSecret,
                    region: this.genesysExternalAccount.region,
                    accessToken: this.genesysExternalAccount.accessToken
                };

                securePost(this.hostUrl + this.integrationUrl, request)
                    .then(data => {
                        this.isLoading = false;
                        if (data && data.success) {
                            this.$emit('saved', { success: true });
                        } else {
                            this.errorMessage = data.message;

                            if (!this.errorMessage) {
                                this.errorMessage = this.defaultErrorMessage;
                            }
                            this.$emit('saved', { success: false, message: this.errorMessage });
                        }
                    })
                    .catch((e) => {
                        this.isLoading = false;
                        this.errorMessage = this.defaultErrorMessage;
                        this.$emit('saved', { success: false, message: this.errorMessage });
                        console.error(e);
                    });
            },
            updateGenesysExternalAccount() {
                this.isLoading = true;

                const request = {
                    id: this.genesysExternalAccount.id,
                    accountId: this.accountId,
                    genesysOrganizationId: this.genesysExternalAccount.genesysOrganizationId,
                    clientId: this.genesysExternalAccount.clientId,
                    clientSecret: this.genesysExternalAccount.clientSecret,
                    region: this.genesysExternalAccount.region,
                    accessToken: this.genesysExternalAccount.accessToken
                };

                securePatch(this.hostUrl + this.integrationUrl, request)
                    .then(data => {
                        this.isLoading = false;
                        if (data && data.success) {
                            this.$emit('saved', { success: true });
                        } else {
                            this.errorMessage = data.message;

                            if (!this.errorMessage) {
                                this.errorMessage = this.defaultErrorMessage;
                            }
                            this.$emit('saved', { success: false, message: this.errorMessage });
                        }
                    })
                    .catch((e) => {
                        this.isLoading = false;
                        this.errorMessage = this.defaultErrorMessage;
                        this.$emit('saved', { success: false, message: this.errorMessage });
                        console.error(e);
                    });
            }
        }
    };
</script>